define('commons/loading-mask',['jquery', 'utils/application-data', 'jquery.ui'], function($, applicationData) {

    var LoadingMask = function(container, options) {
        var settings = $.extend({
            maskColor: '#FFFFFF',
            iconColor: 'black',
            iconPosition: 'center',
            iconSize: 'initial',
            progressBar: false,
            progress: true
        }, options);
        var maskColorCss = "background-color: " + settings.maskColor + ";";
        var maskLoading = "";
        var iconBgCss;
        if (settings.progressBar) {
            iconBgCss = 'background: ' + settings.iconColor + ' ' + settings.iconPosition + ';';
            maskLoading = "<div id='progressBar'><div class='progress-label'>Loading...</div></div>";
        } else if (settings.progress){
            iconBgCss = 'background: url("/resources/img/loading-' + settings.iconColor + '.gif?v=' + applicationData.version + '") ' +
                    settings.iconPosition + ' no-repeat; background-size: ' + settings.iconSize + ';';
            maskLoading = "<div class='maskLoading' style='" + iconBgCss + "'></div>";
        }
        this.mask = $("<div class='maskContainer'><div class='maskFilter' style='" + maskColorCss + "'></div>" + maskLoading + "</div>");
        this.container = $(container);
        var pos = this.container.css("position");
        if (pos != "relative" && pos != "absolute") {
            this.container.css("position", "relative");
        }
        this.container.append(this.mask);
        if (settings.progressBar) {
            var progressbar = $("#progressBar");
            progressbar.progressbar({
                value: false
            });
            var progressbarValue = progressbar.find(".ui-progressbar-value");
            progressbarValue.css("background", settings.iconColor);
        }
        this.mask.hide();
    };
    LoadingMask.prototype.disabled = function(disabled) {
        if (disabled) {
            this.mask.children(".maskLoading").hide();
            this.mask.show();
        } else {
            this.mask.children(".maskLoading").show();
            this.mask.hide();
        }
    };

    LoadingMask.prototype.show = function() {
        this.mask.show();
    };

    LoadingMask.prototype.hide = function() {
        this.mask.hide();
    };

    LoadingMask.prototype.detach = function() {
        this.mask.detach();
    };

    LoadingMask.prototype.attach = function() {
        this.container.append(this.mask);
    };

    LoadingMask.prototype.progressbar = function(progress) {
        $("#progressBar").progressbar("option", {
            value: progress
        });
        $(".progress-label").text(progress + "%");
    };
    
    return LoadingMask;
});

